const KEY = "salvilo_consent";
const MAX_AGE = 180 * 24 * 3600 * 1000;
export const OPEN_EVENT = "salvilo:cookie-prefs";

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c && Date.now() - c.ts < MAX_AGE ? c : null;
  } catch {
    return null;
  }
}

export function saveConsent(analytics) {
  const prev = getConsent();
  localStorage.setItem(KEY, JSON.stringify({ necessary: true, analytics, ts: Date.now() }));
  if (prev?.analytics && !analytics) {
    document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("_ga"))
      .forEach((n) => { document.cookie = `${n}=; Max-Age=0; path=/; domain=.${window.location.hostname}`; document.cookie = `${n}=; Max-Age=0; path=/`; });
    window.location.reload();
  }
}

export const openCookiePrefs = () => window.dispatchEvent(new Event(OPEN_EVENT));

let gaLoaded = false;
let gaCurrent = "";
export function setAnalyticsEnabled(on) {
  if (gaCurrent) window[`ga-disable-${gaCurrent}`] = !on;
}
export function loadAnalytics(gaId) {
  if (gaLoaded || !gaId) return;
  gaLoaded = true;
  gaCurrent = gaId;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", gaId, { anonymize_ip: true });
}
